export const reports = {
  All_reports: "Tous les rapports",
  Areas_for_Improvement: "Axes d'amélioration",
  Assessment: "Évaluation",
  Assessment_of_Conformity: "Évaluation de conformité",
  Assessment_Detail_Report_Link: "Lien vers le Rapport Détaillé d'Évaluation",
  Conformity_Level: "Niveau de conformité",
  Conformity_levels_may_have_been_adjusted:
    "Veuillez noter que les niveaux de conformité dans ce rapport de résumé standard peuvent avoir été ajustés pour répondre aux directives de chaque organisation de standards, ce qui peut entraîner un niveau de conformité différent de celui évalué à l'origine.",
  aggregate_levels: {
    label: "Niveau de conformité agrégé à",
    requirement: "Exigence",
    sub_section: "Sous-section",
    section: "Section",
  },
  custom_report: {
    Add_report_name: "Ajouter un nom de rapport",
    aggregated: "Agrégé",
    Are_you_sure_you_want_to_delete_report: "Êtes-vous sûr de vouloir supprimer ce rapport ?",
    Are_you_sure_you_want_to_modify_report_name: "Êtes-vous sûr de vouloir modifier le nom du rapport ?",
    Conformity_level: "Niveau de conformité",
    Create_Custom_Report: "Créer un rapport personnalisé",
    Download_entire_table: "Télécharger le tableau entier",
    "Download_filtered_&_customized_table": "Télécharger le tableau filtré et personnalisé",
    Export_to_file: "Exporter vers un fichier",
    Name_cannot_be_empty: "Le nom ne peut pas être vide",
    Please_define_data_for_your_custom_report: "Veuillez définir les données pour votre rapport personnalisé",
    Report_name: "Nom du rapport",
    requirement: "Exigence",
    section: "Section",
    section_ref: "Réf. de section",
    Select_an_assessment: "Sélectionner une évaluation",
    Select_sites_and_facilities: "Sélectionner des sites et installations",
    Select_standards: "Sélectionner des standards",
    standard_name: "Nom du standard",
    standard_reference: "Référence du standard",
    sub_section: "Sous-section",
    sub_section_ref: "Réf. de sous-section",
    This_action_cannot_be_undone: "Cette action ne peut pas être annulée",
    This_file_will_contain_report_based_on_all_the_customizations_and_filters_you_have_applied:
      "Ce fichier contiendra le rapport basé sur toutes les personnalisations et filtres que vous avez appliqués",
    This_file_will_contain_whole_report: "Ce fichier contiendra l'ensemble du rapport",
    Use_this_window_to_create_multi_site_multi_standard_report:
      "Utilisez cette fenêtre pour créer un rapport multi-sites, multi-standards",
  },
  Custom_Reports: "Rapports personnalisés",
  Customize_table: "Personnaliser le tableau",
  Download_entire_report: "Télécharger le rapport entier",
  Download_filtered_customized_report: "Télécharger le rapport filtré et personnalisé",
  Download_report: "Télécharger le rapport",
  Evidence: "Preuve",
  Evidence_Description: "Description de la preuve",
  filteredRecords_Results: "{{filteredRecords}} résultats",
  Group_by: "Grouper par",
  Group_by_assessment: "Grouper par évaluation",
  Group_by_site: "Grouper par site",
  In_progress: "En cours",
  Internal_audit_required: "Audit interne",
  IRMA_Achievement_Level: "Niveau de réalisation IRMA",
  Please_select_the_preferred_format: "Veuillez sélectionner le format préféré",
  Protocol_ID: "ID de protocole",
  Protocol_Question: "Question de protocole",
  Reference: "Référence",
  Reports: "Rapports",
  Requirement: "Exigence",
  Reset_to_default: "Réinitialiser par défaut",
  Section: "Section",
  Section_ref: "Réf. de section",
  Site_name: "Nom du site",
  Stakeholder_approval_required: "Engagement des parties prenantes",
  Standard: "Standard",
  Standard_Reference: "Référence du standard",
  Status: "Statut",
  Sub_Section: "Sous-section",
  Sub_Section_Ref: "Réf. de sous-section",
  Sub_Theme: "Sous-thème",
  Table_customization: "Personnalisation du tableau",
  Theme: "Thème",
  This_assessment_is_in_progress_The_assessment_data_you_are_viewing_are_subject_to_change:
    "Cette évaluation est en cours. Les données d'évaluation que vous visualisez sont sujettes à modification.",
  This_report_will_contain_all_protocol_questions_for_title_for_siteName:
    "Ce rapport contiendra toutes les questions de protocole pour {{- title}} pour {{- siteName}}.",
  This_report_will_contain_protocol_questions_for_title_for_siteName_based_on_all_the_customizations_and_filters_you_have_applied:
    "Ce rapport contiendra les questions de protocole pour {{- title}} pour {{- siteName}} basées sur toutes les personnalisations et filtres que vous avez appliqués",
  totalRecords_Results: "{{totalRecords}} résultats",
} as const;
